import { call, put, takeLatest } from 'redux-saga/effects'
import { AsyncAction } from 'src/utils/reduxUtils'
import { FetchLMSTrainingState, CompleteLMSTrainingStep } from 'src/constants/actionTypes'
import { ApiService, callClientSecureApi } from './api/callApi'
import { Endpoints } from 'src/constants/endpoints'
import { LMSTrainingState } from 'src/interfaces/lmsTraining'
import { captureSentryError } from 'src/utils/sentry'

interface FetchLMSTrainingStateRequest {
  stepId: string
  lmsTrainingId: string
}

function* onFetchLMSTrainingState(
  action: AsyncAction<FetchLMSTrainingStateRequest, LMSTrainingState>,
) {
  const { lmsTrainingId, stepId } = action.payload

  try {
    const { payload }: { payload: LMSTrainingState } = yield call(
      callClientSecureApi,
      Endpoints.FetchLMSTrainingState,
      {
        apiService: ApiService.Paraworks,
        method: 'GET',
        query: {
          stepId,
          lmsTrainingId,
        },
      },
    )

    yield put(FetchLMSTrainingState.success())

    if (action.next) {
      action.next(null, payload)
    }
  } catch (err: any) {
    captureSentryError(err, {
      message: '[saga.lmsTraining.onFetchLMSTrainingState] error',
    })

    const errorMessage = err?.payload?.message || 'Failed to fetch LMS training info'

    yield put(FetchLMSTrainingState.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

interface CompleteLMSTrainingStepRequest {
  stepId: string
}

function* onCompleteLMSTrainingStep(
  action: AsyncAction<CompleteLMSTrainingStepRequest, LMSTrainingState>,
) {
  const { stepId } = action.payload

  try {
    const { payload }: { payload: LMSTrainingState } = yield call(
      callClientSecureApi,
      Endpoints.CompleteLMSTrainingStep,
      {
        apiService: ApiService.Paraworks,
        method: 'POST',
        body: {
          stepId,
        },
      },
    )

    yield put(CompleteLMSTrainingStep.success())

    if (action.next) {
      action.next(null, payload)
    }
  } catch (err: any) {
    captureSentryError(err, {
      message: '[saga.lmsTraining.onCompleteLMSTrainingStep] error',
    })

    const errorMessage = err?.payload?.message || 'Failed to complete LMS training step'

    yield put(CompleteLMSTrainingStep.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* lmsTrainingSaga() {
  yield takeLatest(FetchLMSTrainingState.type.REQUEST, onFetchLMSTrainingState)
  yield takeLatest(CompleteLMSTrainingStep.type.REQUEST, onCompleteLMSTrainingStep)
}
